export const haveValue = (val) => {
  if (
    val !== "" &&
    val !== "undefined" &&
    val !== undefined &&
    val !== null &&
    val !== "null"
  ) {
    return true;
  } else {
    return false;
  }
};

export const getClassName = (value) => {
  if (value) {
    return "green";
  } else {
    return "red";
  }
};

export const getEmailDomain = (email) => {
  if (!email || typeof email !== "string") return "Not found";

  const trimmed = email.trim().toLowerCase();

  const atIndex = trimmed.lastIndexOf("@");
  if (atIndex === -1 || atIndex === trimmed.length - 1) return "Not found";

  const domainPart = trimmed.slice(atIndex + 1);

  // Remove TLD (.com, .co.in, etc.)
  const domainName = domainPart.split(".")[0];

  return domainName || "Not found";
}
